module.exports = __webpack_public_path__ + "img/zfcg_04.1bbfe491.png";